<template>
  <SetBankTemplate
    needStepBar
    needBottomActionButtons
    @updated="onUpdated"
    @skipped="onSkipped"
  />
</template>

<script lang="ts">
import { Component, Vue } from "vue-facing-decorator";
import SetBankTemplate from "@/components/templates/SetBankTemplate.vue";
import { sendAdjustEvent } from "@/plugins/adjust";
import { sendFirebaseCustomEvent } from "@/plugins/firebase";
import { authStore } from "@/store/auth";
import { routerPush } from "@/utils/routerPush";
@Component({
  components: {
    SetBankTemplate
  }
})
export default class RegisterSetBank extends Vue {
  async onUpdated() {
    await routerPush(this, { name: "RegisterBusinessInfo" });
  }

  async onSkipped() {
    sendAdjustEvent("SKIP_INPUT_BANK_ACCOUNT");
    sendFirebaseCustomEvent("skip_input_bank_account", {
      session_id: authStore.sessionId || "unknown"
    });
    await routerPush(this, { name: "RegisterFinishSignup" });
  }
}
</script>
